export enum LineThicknesses {
  thin = 1,
  medium = 2,
  thick = 4
}
export type LineThicknessKeys = 'thin' | 'medium' | 'thick';

export enum DashID {
  solid = 'solid',
  dlgl = 'dlgl',
  dmgm = 'dmgm',
  dsgs = 'dsgs',
  dlgm = 'dlgm',
  dmgs = 'dmgs',
  dsgd = 'dsgd',
  dldgm = 'dldgm',
  dmdgs = 'dmdgs',
  dsdgd = 'dsdgd',
  dlddgm = 'dlddgm',
  dmddgs = 'dmddgs',
  dsddgd = 'dsddgd',
  dldddgm = 'dldddgm',
  dmdddgs = 'dmdddgs',
  dsdddgd = 'dsdddgd',
  dgm = 'dgm',
  dgs = 'dgs',
  dgd = 'dgd'
}
export type DashInfoRecord = {
  dash: number,
  dots: number,
  gap: number,
  offset: number,
  label: string
}
export class DashInfo {
  public static [DashID.solid] = { dash: 100, dots: 0, gap: 0, offset: 0, label: 'solid' };
  public static [DashID.dlgl] = { dash: 25, dots: 0, gap: 25, offset: 12.5, label: 'Long Dash' };
  public static [DashID.dmgm] = { dash: 12.25, dots: 0, gap: 12.25, offset: 6.25, label: 'Medium Dash' };
  public static [DashID.dsgs] = { dash: 6.5, dots: 0, gap: 6.5, offset: 3.125, label: 'Small Dash' };
  public static [DashID.dlgm] = { dash: 25, dots: 0, gap: 12.25, offset: 17.5, label: 'Long Dash w/ Medium Gap' };
  public static [DashID.dmgs] = { dash: 12.25, dots: 0, gap: 6.5, offset: 12.5, label: 'Medium Dash w/ Small Gap' };
  public static [DashID.dsgd] = { dash: 6.5, dots: 0, gap: 3.25, offset: 5, label: 'Small Dash w/ Dot-gap' };
  public static [DashID.dldgm] = { dash: 25, dots: 1, gap: 12.25, offset: 17.5, label: 'Long Dash - Dot' };
  public static [DashID.dmdgs] = { dash: 12.25, dots: 1, gap: 6.5, offset: 12.5, label: 'Medium Dash - Dot' };
  public static [DashID.dsdgd] = { dash: 6.5, dots: 1, gap: 3.25, offset: 5, label: 'Small Dash - Dot' };
  public static [DashID.dlddgm] = { dash: 25, dots: 2, gap: 12.25, offset: 29.5, label: 'Large Dash - Dot - Dot' };
  public static [DashID.dmddgs] = { dash: 12.25, dots: 2, gap: 6.5, offset: 8.5, label: 'Medium Dash - Dot - Dot' };
  public static [DashID.dsddgd] = { dash: 6.5, dots: 2, gap: 3.25, offset: 2.5, label: 'Small Dash - Dot -Dot' };
  public static [DashID.dldddgm] = { dash: 25, dots: 3, gap: 12.25, offset: 2.5, label: 'Large Dash - Dot - Dot - Dot' };
  public static [DashID.dmdddgs] = { dash: 12.25, dots: 3, gap: 6.5, offset: 0, label: 'Medium Dash - Dot - Dot - Dot' };
  public static [DashID.dsdddgd] = { dash: 6.5, dots: 3, gap: 3.25, offset: 2.25, label: 'Small Dash - Dot - Dot - Dot' };
  public static [DashID.dgm] = { dash: '2', dots: 0, gap: 12.25, offset: 8.25, label: 'Dotted w/ Medium Gap' };
  public static [DashID.dgs] = { dash: '2', dots: 0, gap: 6.5, offset: 4.25, label: 'Dotted w/ Small Gap' };
  public static [DashID.dgd] = { dash: '2', dots: 0, gap: 3.25, offset: 2.25, label: 'Dotted' };
  public static Get(id: DashID) {
    return (DashInfo as any)[id];
  }
  public static GetDashArray(dashInfo: DashInfoRecord, thickness: 'thin' | 'medium' | 'thick'): string {
    if (!dashInfo) return '';
    let dashStr = '';
    if (dashInfo.dash === 100) return '';
    let dashSize = dashInfo.dash; // * this._width/100.0;
    let gapSize = dashInfo.gap; // * this._width/100.0;
    let dotSize = 2; // * this._width/100.0;
    switch (thickness) {
      case 'thin':
        dashSize *= .5;
        gapSize *= .5;
        dotSize *= .5;
        break;
      case 'medium':
        break;
      case 'thick':
        dashSize *= 1.5;
        gapSize *= 1.5;
        dotSize *= 1.5;
    }
    dashStr += dashSize + ' ' + gapSize;
    if (dashInfo.dots) {
      for (let i = 0; i < dashInfo.dots; i++) {
        dashStr += ` ${dotSize} ${gapSize}`;
      }
    }
    return dashStr;
  }

  public static GetDashOffset(dashInfo: DashInfoRecord, thickness: 'thin' | 'medium' | 'thick'): string {
    if (!dashInfo) return '';
    if (dashInfo.dash === 100) return '';
    if (!dashInfo.offset) return '';
    switch (thickness) {
      case 'thin':
        return '' + dashInfo.offset * .5;
      case 'medium':
        return '' + dashInfo.offset * 1;
      case 'thick':
        return '' + dashInfo.offset * 1.5;
    }
  }

}

